import { useReactiveVar } from "@apollo/client";
import { localEditorIsPreviewM2Layouts } from "../../State";

export const useEditorIsPreviewM2 = (): boolean => {
    return useReactiveVar(localEditorIsPreviewM2Layouts);
};
